import { Pipe, PipeTransform } from '@angular/core';
import { UserRole } from '@shared/data-access';

@Pipe({
  name: 'hasOrganizationUserRole',
})
export class HasOrganizationUserRolePipe implements PipeTransform {
  private readonly organizationRoles: UserRole[] = [
    UserRole.DistributorAccountUser,
    UserRole.DistributorAccountManagerA,
    UserRole.DistributorAccountManagerB,
    UserRole.DistributorAccountManagerC,

    UserRole.MerchantAccountUser,
    UserRole.MerchantAccountManagerA,
    UserRole.MerchantAccountManagerB,
    UserRole.MerchantAccountManagerC,

    UserRole.BrandAccountUser,
    UserRole.BrandAccountManagerA,
    UserRole.BrandAccountManagerB,
    UserRole.BrandAccountManagerC,
  ];

  transform(userRoles: UserRole[]): boolean {
    return this.organizationRoles.some((role) => userRoles.includes(role));
  }
}
